/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 24/10/2023
 */

import React from "react";
import styles from "./Footer.module.css";
import { Link, useNavigate } from "react-router-dom";
import {
  Container,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { useGetAllTopCategoriesQuery } from "../../Store/Services/CategoryService";
import { Facebook, Instagram, WhatsApp } from "@mui/icons-material";

const links = [
  { id: 1, name: "Home", to: "/" },
  { id: 2, name: "Services", to: "/services" },
  { id: 3, name: "About Us", to: "/aboutUs" },
  { id: 4, name: "Contact", to: "/contact" },
  { id: 5, name: "Reviews", to: "/#reviews" },
];

const Footer = ({ id }) => {
  const navigate = useNavigate();

  const { data: categories, isSuccess } = useGetAllTopCategoriesQuery();

  const handleLinkClick = (link) => {
    if (link.id === 5) {
      navigate("/");
      setTimeout(() => {
        const reviewsSection = document.getElementById("reviews");
        if (reviewsSection) {
          reviewsSection.scrollIntoView({ behavior: "smooth" });
        } else {
          console.log("Reviews section not found!");
        }
      }, 0);
    } else {
      navigate(link.to);
    }
  };
  return (
    <Container style={{ maxWidth: "94rem" }}>
      <div className={styles.footer}>
        <div className={styles.horizontalLine}></div>
        <div className={styles.subContainer}>
          <div className={styles.address}>
            <Grid container>
              <Grid item xs={3.5}>
                <Typography>Head Office</Typography>
              </Grid>
              <Grid item xs={0.5}>
                <Typography>:</Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography>DoneRight Housekeeping Services</Typography>
                <Typography>Adelaide,</Typography>
                <Typography>South Australia</Typography>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={3.5}>
                <Typography>Phone</Typography>
                <Typography>E-mail</Typography>
              </Grid>
              <Grid item xs={0.5}>
                <Typography>:</Typography>
                <Typography>:</Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography>+61 456 793 943</Typography>
                <Typography className={styles.email}>
                  <a
                    href="https://mail.google.com/mail/?view=cm&fs=1&to=info@doneright247.au"
                    style={{ textDecoration: "none", color: "inherit" }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    info@doneright247.au
                  </a>
                </Typography>
              </Grid>
            </Grid>
          </div>
          <div className={styles.linkContainer}>
            <div>
              <List className={styles.linkList}>
                {links.map((link) => (
                  <ListItem key={link.id}>
                    <Link to={link.to} onClick={() => handleLinkClick(link)}>
                      <ListItemText
                        className={styles.listItem}
                        primary={
                          <Typography style={{ fontWeight: "bold" }}>
                            {link.name}
                          </Typography>
                        }
                      />
                    </Link>
                  </ListItem>
                ))}
              </List>
            </div>
            {/* <div className={styles.categoryLinks}>
              <List className={styles.linkList}>
                {categories.map((link) => (
                  <ListItem key={link.catId}>
                    <Link to={link.to} onClick={() => handleLinkClick(link)}>
                      <ListItemText
                        className={styles.listItem}
                        primary={
                          <Typography style={{ fontWeight: "bold" }}>
                            
                            {link.catDisplay}
                          </Typography>
                        }
                      />
                    </Link>
                  </ListItem>
                ))}
              </List>
            </div> */}
            <div id={id} className={styles.categoryLinks}>
              <List className={styles.linkList}>
                {Array.isArray(categories) &&
                  categories.map((category) => (
                    <ListItem key={category.catId}>
                     <Link
                      to={`/checkout/${category.catDisplay
                         .split(` `)
                        .join(`-`)
                         .split(`?`)
                         .join(``)
                         .toLowerCase()}?id=${category.catUuid}`}
                         style={{ textDecoration: "none", color: "inherit" }}
                        >
                        <Typography
                          className={styles.listItem}
                          style={{ fontWeight: "bold" }}
                        >
                          {category.catDisplay}
                        </Typography>
                      </Link>
                    </ListItem>
                  ))}
              </List>
            </div>
          </div>
          <div>
            <Typography className={styles.contacts}>Contact Us</Typography>
            <div
              className={styles.buttonContainer}
              style={{ marginLeft: "-10px", marginTop: "-20px" }}
            >
              <IconButton style={{ color: "white" }}>
                <Link
                  to="https://www.facebook.com/donerighthousekeepers.fb"
                  target="_blank"
                >
                  <Facebook sx={{ fontSize: 32 }} />
                </Link>
              </IconButton>
              <IconButton style={{ color: "white" }}>
                <Link
                  to="https://www.instagram.com/donerighthousekeepers.sa?igsh=MWlzbG04Ynk1MzFhaQ=="
                  target="_blank"
                >
                  <Instagram sx={{ fontSize: 32 }} />
                </Link>
              </IconButton>
              <IconButton style={{ color: "white" }}>
                <a href="https://wa.me/61456793943" target="_blank">
                  <WhatsApp sx={{ fontSize: 32 }} />
                </a>
              </IconButton>
            </div>
            <div className={styles.logoDiv}>
              <Link to="/">
                <img
                  className={styles.logo}
                  alt="logo"
                  src={`${process.env.REACT_APP_IMAGE_URL}DoneRight/HOME/doneRightLogo.png`}
                  loading="lazy"
                />
              </Link>
            </div>
          </div>
        </div>
        <Typography 
  component="a" 
  href="https://n-ach.com/" 
  target="_blank" 
  rel="noopener noreferrer" 
  className={styles.nAch}
  style={{ 
    fontWeight: 500,
        textAlign: 'center', 
    display: 'block', 
    textDecoration: 'none', 
    color: 'black',
    fontSize: '12px',
    paddingTop:'1rem'
  }}
>
All Rights Reserved By N-ACH | V 1.0.1 
</Typography>
        <Typography 
  component="a" 
  href="https://n-ach.com/" 
  target="_blank" 
  rel="noopener noreferrer" 
  className={styles.nAch}
  style={{ 
    fontWeight: 500,
        textAlign: 'center', 
    display: 'block', 
    textDecoration: 'none', 
    color: 'black',
    fontSize: '12px',
    paddingTop:'0rem'
  }}
>
  Powered & Managed by N-ACH
</Typography>
      </div>
    </Container>
  );
};

export default Footer;
